<div class="grid flex flex-row flex-wrap surface-card shadow-2 p-2">
  <div
    *ngIf="technicalRecordData.record_type === 'Service'"
    class="col-4 flex flex-column"
  >
    <div class="text-500">Service Brakes</div>
    <div>
      <span class="text-gray-900 white-space-nowrap">
        {{ technicalRecordData.service_brakes }}%
      </span>
    </div>
  </div>
  <div
    *ngIf="technicalRecordData.record_type === 'Service'"
    class="col-4 flex flex-column"
  >
    <div class="text-500">Service Type</div>
    <div>
      <span class="text-gray-900 white-space-nowrap">
        {{ technicalRecordData.service_type }}
      </span>
    </div>
  </div>
  <div>
    <div
      *ngIf="technicalRecordData.record_type === 'Service'"
      class="col-4 flex flex-column"
    >
      <div class="text-500">Service Job Number</div>
      <div>
        <span class="text-gray-900 white-space-nowrap">
          {{ technicalRecordData.service_jobno }}
        </span>
      </div>
    </div>
  </div>
  <div *ngIf="technicalRecordData.record_type === 'Tyre'" class="col-4 flex flex-column">
    <div class="text-500">Tyre Position</div>
    <div>
      <span class="text-gray-900 white-space-nowrap">
        {{ technicalRecordData.tyre_pos }}
      </span>
    </div>
  </div>
  <div *ngIf="technicalRecordData.record_type === 'Tyre'" class="col-4 flex flex-column">
    <div class="text-500">Tyre Size</div>
    <div>
      <span class="text-gray-900 white-space-nowrap">
        {{ technicalRecordData.tyre_size }}
      </span>
    </div>
  </div>
  <div *ngIf="technicalRecordData.record_type === 'Tyre'" class="col-4 flex flex-column">
    <div class="text-500">Tyre Type</div>
    <div>
      <span class="text-gray-900 white-space-nowrap">
        {{ technicalRecordData.tyre_type }}
      </span>
    </div>
  </div>
  <div class="col-4 flex flex-column">
    <div class="text-500">Description Tag</div>
    <div>
      <span class="text-gray-900 white-space-nowrap">
        {{ technicalRecordData.description_tag }}
      </span>
    </div>
  </div>
  <div class="col-4 flex flex-column">
    <div class="text-500">Remarks</div>
    <div>
      <span class="text-gray-900 white-space-nowrap">
        {{ technicalRecordData.remarks }}
      </span>
    </div>
  </div>
  <div class="col-4 flex flex-column">
    <div class="text-500">Record Type</div>
    <div>
      <span class="text-gray-900 white-space-nowrap">
        {{ technicalRecordData.record_type }}
      </span>
    </div>
  </div>
</div>
